import { observable, action, computed } from 'mobx';
import ContainerStore from 'poly-eshop4/eshop/ui/js/store/container';

// ReturnsOrder Store
export default class ReturnsOrderStore extends ContainerStore {
  @observable items = new Map();
  @observable activePositionCount = null;
  @observable activeLabel = null;

  @computed get isActiveEmpty() {
    return this.activePositionCount === null ? null : !this.activePositionCount;
  }

  @computed get hasActivePositions() {
    return this.activePositionCount === null ? null : !!this.activePositionCount;
  }

  update(data) {
    // Reload checkout if checkout is active
    // because of returnsorder in checkout
    if ($('[data-bind-html="checkout:html"]').length > 0) {
      $.stores.checkout.load();
    }

    if (data.container && data.container.container_type === 'returns_cart') {
      this.activePositionCount = data.container ? data.container.position_count : null;
      this.activeLabel = data.container.label;
    }

    if (data.container) {
      const htmlEl = $('[data-bind-html="returnsorder:html"]');
      const dataContainerId = htmlEl.attr('data-container-id');
      if (htmlEl.length === 0 || !dataContainerId || parseInt(dataContainerId, 10) === data.container.id) {
        super.update(data);
      }
    } else {
      super.update(data);
    }
  }

  @action
  post(url, formdata) {
    return super.post(url, formdata).then((result) => {
      if (result.position && this.items.has(result.position.item_id)) {
        this.items.get(result.position.item_id).set('quantity', parseFloat(result.position.quantity));
        this.items.get(result.position.item_id).set('deleteUrl', result.position.delete_url);
        this.items.get(result.position.item_id).set('positionCount', result.position.position_count);
      } else if (result.item_id && this.items.has(result.item_id)) {
        this.items.get(result.item_id).set('quantity', '');
        this.items.get(result.item_id).set('deleteUrl', '');
        this.items.get(result.item_id).set('positionCount', '');
      }
      if (result.group_select) {
        $(result.group_select).foundation().foundation('open');
      }
      return result;
    });
  }

  @action
  clear(url, formdata) {
    return super.post(url, formdata).then(() => {
      this.items = new Map();
    });
  }
}
